import { render, staticRenderFns } from "./SocialAdEngagementStatItem.vue?vue&type=template&id=183df171&"
import script from "./SocialAdEngagementStatItem.vue?vue&type=script&lang=js&"
export * from "./SocialAdEngagementStatItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports